import { useTranslation } from 'react-i18next';
import OwnerForm from '../../../components/owner/OwnerForm';

export default function OwnerCreate() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen w-screen flex flex-col md:flex-row bg-light overflow-hidden">
      <div className="hidden md:block md:w-1/2 h-screen">
        <img src={"/main.png"} alt="Register" className="w-full h-full object-cover" />
      </div>

      <div className="flex flex-1 justify-center items-center p-8 md:p-16 min-h-screen">
        <div className="w-full max-w-md p-6 md:p-8">
          <h1 className="text-2xl text-center font-bold text-Black mb-2">{t('owner.registerTitle')}</h1>
          <p className="text-Black font-normal text-center mb-6">{t('owner.registerHeadline')}</p>

          <OwnerForm
            successRedirect="/store/dashboard"
            submitLabel={t('owner.registerButton')}
            successMessage={t('owner.registerSuccess')}
          />
        </div>
      </div>
    </div>
  );
}
